import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import StarRating from 'common/components/star_rating';
import Thumbnail from 'common/components/thumbnail';
import Utils from 'focus_groups/utils';

const ResultTile = ({ id, votes, revision, entry_number, onClick }) => {
  const { averageScore, numVotes, numComments, thumbnailImage } = Utils({ votes, revision });

  return (<div className="column">
            <div className="tile focus-group-result-tile">
              <div className="row align-center">
                <div className="columns small-16 medium-5 large-5">
                  <Thumbnail className="thumbnail flex" onClick={partial(onClick, id)}
                    image={thumbnailImage} />
                </div>
                <div className="columns small-16 medium-11 large-11 align-middle">
                  <h4>Entry #{entry_number}</h4>
                  <div className="focus-group-stats tile-stats">
                    <div className="row collapse small-up-3 medium-up-4">
                      <div className="column">
                        <span className="stat-label">Group Score</span>
                        <div className="stat-value">{averageScore}</div>
                      </div>
                      <div className="column">
                        <span className="stat-label">Votes</span>
                        <div className="stat-value">{numVotes}</div>
                      </div>
                      <div className="column">
                        <span className="stat-label">Comments</span>
                        <div className="stat-value">{numComments}</div>
                      </div>
                      <div className="column hide-for-small-only">
                        <span className="stat-label">Your Score</span>
                        <div className="stat-value">
                          <StarRating readonly={true} initialRate={revision.score}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>);
};

ResultTile.propTypes = {
  id: PropTypes.number.isRequired,
  votes: PropTypes.object.isRequired,
  revision: PropTypes.object.isRequired,
  entry_number: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

export default ResultTile;



// WEBPACK FOOTER //
// ./focus_groups/components/result_tile.jsx